import { render, staticRenderFns } from "./footprintFoot.vue?vue&type=template&id=5947b5a6&scoped=true&"
import script from "./footprintFoot.vue?vue&type=script&lang=js&"
export * from "./footprintFoot.vue?vue&type=script&lang=js&"
import style0 from "./footprintFoot.vue?vue&type=style&index=0&id=5947b5a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5947b5a6",
  null
  
)

export default component.exports